import { render } from "./TopMenu.vue?vue&type=template&id=60e5a2fc"
import script from "./TopMenu.vue?vue&type=script&lang=js"
export * from "./TopMenu.vue?vue&type=script&lang=js"

import "./TopMenu.vue?vue&type=style&index=0&id=60e5a2fc&lang=scss"

import exportComponent from "/home/runner/work/maider/maider/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__